import React           from "react";
import PropTypes       from 'prop-types';
import Constants, { getTypeByColor }       from './Constants';
import Flux            from '../../flux/Flux';
import Alert from "../Alert/Alert";

export default class StatusBarWelcomeBack extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isVisible: this.props.isVisible,
		};

		this.removeStatusBar = this.removeStatusBar.bind(this);
	}

	componentDidMount() {
		Flux.Browser.addStatusBarWindowClickListener(this.removeStatusBar);
	}

	componentWillUnmount() {
		Flux.Browser.removeStatusBarWindowClickListener(this.removeStatusBar);
	}

	removeStatusBar() {
		this.setState({
			isVisible: false,
		});
	}

	render() {
        if (!this.state.isVisible) {
            return null;
        }
		return <Alert
            type={getTypeByColor(this.props.barColor)}
            text={this.props.msgOutro}
        />;
	}
}

StatusBarWelcomeBack.propTypes = {
	barColor:           PropTypes.string.isRequired,
	msgOutro:           PropTypes.string.isRequired,
	isVisible:          PropTypes.bool.isRequired,
};

StatusBarWelcomeBack.defaultProps = {
	barColor: Constants.BARCOLOR_WHITE,
};
